import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Button } from "react-bootstrap";
import DataTable from "../../components/DataTable"
import Modal from "../../components/Modal"


const ServiceType = () => {
    const [serviceTypes, setServiceTypes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("add");
    const [formData, setFormData] = useState({ title: "", image: null, id: null });

    useEffect(() => {
        fetchServiceTypes();
    }, []);

    const fetchServiceTypes = async () => {
        try {
            const response = await axios.get("https://api.glyphqai.com/api/get-servicetype");
            if (response.data.status === 200) {
                setServiceTypes(response.data.service_type);
            }
        } catch (err) {
            console.error("Error fetching service types:", err);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, image: file });
        }
    };

    const handleOpenModal = (type, service = null) => {
        setModalType(type);
        if (type === "edit" && service) {
            setFormData({ title: service.title, image: null, id: service.id });
        } else {
            setFormData({ title: "", image: null, id: null });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Create FormData object
        const formDataToSend = new FormData();
        formDataToSend.append("title", String(formData.title).trim()); // Ensure title is correctly formatted
        if (formData.image) {
            formDataToSend.append("image", formData.image);
        }

        try {
            if (modalType === "add") {
                await axios.post(
                    "https://api.glyphqai.com/api/store-servicetype",
                    formDataToSend,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                toast.success("Service type added successfully!");
            } else if (modalType === "edit") {
                formDataToSend.append("_method", "PUT")
                await axios.post( // Use PATCH instead of PUT
                    `https://api.glyphqai.com/api/update-servicetype/${formData.id}`,
                    formDataToSend,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                toast.success("Service type updated successfully!");
            }

            fetchServiceTypes();
            handleCloseModal();
        } catch (error) {
            console.error("Error saving service type:", error.response || error);
            toast.error(`Failed to ${modalType === "add" ? "add" : "update"} service type.`);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://api.glyphqai.com/api/deleteservicetype/${id}`);
            setServiceTypes(serviceTypes.filter((type) => type.id !== id));
            toast.success("Service type deleted successfully!");
        } catch (error) {
            console.error("Error deleting service type:", error);
            toast.error("Failed to delete service type.");
        }
    };

    return (
        <>
            <div className="container">
                <div className="my-3 mt-5 d-flex justify-content-between">
                    <h2 className="font-bold display-5">Service Types</h2>
                    <Button onClick={() => handleOpenModal("add")} className="mb-3">
                        Add Service Type
                    </Button>
                </div>
                <DataTable
                    headers={["#", "Title", "Image"]}
                    data={serviceTypes}
                    dataKeyMap={["id", "title", "image"]}
                    imagePath="https://api.glyphqai.com/uploads/servicetype/"
                    actions={[
                        { label: "Edit", variant: "primary", onClick: (row) => handleOpenModal("edit", row) },
                        { label: "Delete", variant: "danger", onClick: (row) => handleDelete(row.id) }
                    ]}
                />
            </div>
            <Modal
                show={showModal}
                handleClose={handleCloseModal}
                title={modalType === "add" ? "Add Service Type" : "Edit Service Type"}
                fields={[
                    { name: "title", label: "Title", type: "text", placeholder: "Enter title", required: true },
                    { name: "image", label: "Image", type: "file", onChange: handleFileChange, accept: "image/*" }
                ]}
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                formData={formData}
            />
            <ToastContainer />
        </>
    );
};

export default ServiceType;

